var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef } from 'react';
import Manager from '@shared/modal/Manager';
import { IoMdClose } from 'react-icons/io';
import { getTagDisplayName, getTagLongName } from '@data/tag/tagUtil';
import { TagType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import { TagBadge } from '@styled/Basic';
import TagModal from '@shared/finder/modals/EditTag';
import { useActionsByTagIdMap } from '@data/tag/tagActions';
import { isAccountTag } from '@data/tag/types';
function Tag(_a) {
    var tag = _a.tag, canUpdate = _a.canUpdate, onDelete = _a.onDelete, parentName = _a.parentName, _b = _a.tiny, tiny = _b === void 0 ? false : _b, _c = _a.isInherited, isInherited = _c === void 0 ? false : _c, _d = _a.style, style = _d === void 0 ? {} : _d;
    var L = useLanguage().L;
    var data = useActionsByTagIdMap().data;
    var labelRef = useRef(null);
    var help = function (type, tag, parentName) {
        var _a;
        Manager.closePopover(); // close old popover if it exists
        var name = (_a = (tag && getTagLongName(tag))) !== null && _a !== void 0 ? _a : '';
        var longName = parentName ? "".concat(parentName, " \u21D2 ").concat(name) : name !== null && name !== void 0 ? name : '';
        Manager.renderTitle('top', labelRef.current, longName);
    };
    var tryOpenEdit = function (e) {
        var _a;
        e.stopPropagation();
        var canUpdate = data ? (_a = data[tag.id]) === null || _a === void 0 ? void 0 : _a.canUpdate : false;
        if (canUpdate) {
            Manager.renderModal(React.createElement(TagModal, { tag: tag }));
        }
    };
    return (React.createElement(TagBadge, { className: "".concat(isAccountTag(tag) ? 'acc' : '', " ").concat(tag.type === TagType.Table ? 'table' : '', " ").concat(tiny ? 'tiny' : ''), style: __assign({ marginRight: '10px' }, style) },
        React.createElement("span", { ref: labelRef, onMouseEnter: function () { return help('t-desc', tag, parentName); }, onMouseLeave: Manager.closePopover, onClick: tryOpenEdit }, getTagDisplayName(tag)),
        canUpdate && !isInherited ? (React.createElement("span", { className: "remove", onClick: onDelete },
            React.createElement(IoMdClose, null))) : (React.createElement(React.Fragment, null))));
}
export default Tag;
